<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  <header>
    <div class="headline">
      <h1>
        {{ isEditing() ? ('Process_Title' | translateWF: 'Processes') + ' ' + process()?.processId : ('Process_New' | translateWF: 'New Process') }}
      </h1>
    </div>
    <div class="buttons">
      <p-button [label]="'Common_Save' | translateWF: 'Save'" [disabled]="formGroup.invalid || !canEdit()" (click)="onSubmit()" />
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <form [formGroup]="formGroup">
      <div class="col">
        <p-panel [header]="'Process_Details' | translateWF: 'General Information'">
          <p-card>
            <div class="col">
              <div class="grid-auto-3">
                @if (isEditing()) {
                  <div class="form-box">
                    <label for="processId">
                      {{ 'Process_ID' | translateWF: 'Process ID' }}
                    </label>
                    <input type="text" [readOnly]="true" [disabled]="true" [value]="process()?.processId" class="w-full p-inputtext p-component" />
                  </div>
                }
                <div class="form-box">
                  <label for="name">
                    {{ 'Process_Name' | translateWF: 'Name' }}
                  </label>
                  <input type="text" id="name" formControlName="name" class="w-full" pInputText />
                </div>
                <div class="form-box">
                  <label for="processType">
                    {{ 'Process_Type' | translateWF: 'Process Type' }}
                  </label>
                  <p-select [options]="allProcessTypes()" optionLabel="name" optionValue="id" formControlName="processType" class="w-full" />
                </div>
              </div>
              <div class="form-box">
                <label for="description">
                  {{ 'Process_Description' | translateWF: 'Description' }}
                </label>
                <textarea pTextarea id="description" formControlName="description" class="w-full"></textarea>
              </div>
              <div class="row-sm-start-center">
                <p-checkbox id="showInFabricGeneralProcessRoute" formControlName="showInFabricGeneralProcessRoute" [binary]="true" />
                <label for="showInFabricGeneralProcessRoute">
                  {{ 'Process_Show_Route' | translateWF: 'Show in Fabric General Process Route' }}
                </label>
              </div>
            </div>
          </p-card>
        </p-panel>

        <app-parameter-details-viewer formControlName="additionalParameters" [canEdit]="canEdit()"></app-parameter-details-viewer>

        <app-item-details-viewer
          [(itemDetailsFormGroups)]="itemDetailsFormGroups"
          [inventoryTypeReference]="inventoryTypeReference()"
          [canEdit]="canEdit()"
        ></app-item-details-viewer>

        <app-step-details-viewer formControlName="steps" [canEdit]="canEdit()" [canEditItems]="canEditItems()" [canEditParameters]="canEditParameters()" />
      </div>
    </form>
  </div>
</main>
